module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.700e0b8e.svg";